import { Building2, UserRound, Activity } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { isImmatriculation } from "@/lib/dossiers";

function InfoCard({ icon: Icon, title, testId, children }) {
    return (
        <Card data-testid={testId} className="border-slate-200 bg-white shadow-sm">
            <CardContent className="pt-6 space-y-5">
                <div className="flex items-center gap-3">
                    <div className="h-9 w-9 rounded-full bg-accent flex items-center justify-center">
                        <Icon className="h-4 w-4 text-primary" strokeWidth={1.75} />
                    </div>
                    <h2 className="font-display text-xl text-foreground">{title}</h2>
                </div>
                <dl className="space-y-3">{children}</dl>
            </CardContent>
        </Card>
    );
}

function Row({ label, value, testId }) {
    return (
        <div>
            <dt className="text-xs uppercase tracking-[0.18em] text-muted-foreground">{label}</dt>
            <dd data-testid={testId} className="mt-1 text-sm text-foreground break-words">{value || "—"}</dd>
        </div>
    );
}

export function EntrepriseCard({ entreprise: e }) {
    return (
        <InfoCard icon={Building2} title="Entreprise" testId="entreprise-card">
            <Row label="Raison sociale" value={e?.nom_entreprise} testId="entreprise-nom" />
            <Row label="SIREN" value={isImmatriculation(e?.siren) ? "En cours d'immatriculation" : e?.siren} testId="entreprise-siren" />
            <Row label="Forme juridique" value={e?.forme_juridique} testId="entreprise-forme" />
            <Row label="Dirigeant" value={e?.nom_gerant} testId="entreprise-gerant" />
            <Row label="Adresse du siège" value={e?.adresse} testId="entreprise-adresse" />
        </InfoCard>
    );
}

export function ClientCard({ client: c }) {
    return (
        <InfoCard icon={UserRound} title="Client" testId="client-card">
            <Row label="Nom" value={c?.prenom_nom} testId="client-nom" />
            <Row label="E-mail" value={c?.email} testId="client-email" />
            <Row label="Profession" value={c?.type_professionnel} testId="client-profession" />
            <Row label="Cabinet" value={c?.nom_cabinet} testId="client-cabinet" />
        </InfoCard>
    );
}

export function ActiviteCard({ documents, kpis, synthese, exercices = [], notes }) {
    return (
        <InfoCard icon={Activity} title="Mission" testId="activite-card">
            <Row label="Exercices à analyser" value={exercices.length ? exercices.join(", ") : null} testId="activite-exercices" />
            <Row label="Contexte" value={notes} testId="activite-notes" />
            <Row label="Documents en dataroom" value={String(documents)} testId="activite-documents" />
            <Row label="Exercices KPI saisis" value={String(kpis)} testId="activite-kpis" />
            <Row label="Synthèse IA" value={synthese ? "Générée" : "Non générée"} testId="activite-ia" />
        </InfoCard>
    );
}
